import { ICalculateResult } from './calculate';

export enum ECalculateStatus {
  Initial = 'initial',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}

interface ICalculateState {
  status: ECalculateStatus;
  result: ICalculateResult | null;
  errorMessage: string;
}

export interface ICalculateStateNotFetched extends ICalculateState {
  status: ECalculateStatus.Initial | ECalculateStatus.Loading | ECalculateStatus.Failed;
  result: null;
}

export interface ICalculateStateFetched extends ICalculateState {
  status: ECalculateStatus.Succeed;
  result: ICalculateResult;
  errorMessage: '';
}

export type TCalculateState = ICalculateStateFetched | ICalculateStateNotFetched;
